export default __webpack_public_path__ + "static/media/a011-example1.1520c0f8.jpg";